import React from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import { ProgressBar } from '@blueprintjs/core'
import NumberFormat from 'react-number-format'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import ReactTable from 'react-table'
import ReactQR from 'react-awesome-qr'
import { CustomButton } from 'components'
import { getBillingCover } from 'ducks/billform'
import logo from 'assets/images/DTGO_logo_with_text.png'
import { CoverContainer, ContactPointContainer, AttachContainer } from './styled'
import './specialStyle.css'
import Note from './Note'

const columns = (currency) => [
  {
    Header: 'Invoice Number',
    accessor: 'invoiceNumber',
    style: { display: 'flex', justifyContent: 'center' }
  }, {
    Header: 'Invoice Amount',
    accessor: 'invoiceAmount',
    Cell: (row) => 
      <div>
        <NumberFormat value={row.value} displayType='text' thousandSeparator decimalScale={2} fixedDecimalScale />
        <span style={{ marginLeft: '0.5rem' }}>{currency}</span>
      </div>,
    style: { textAlign: 'right', paddingRight: '10px' },
    width: 120,
  }, {
    Header: 'DN Type',
    accessor: 'dnType',
    style: { fontSize: '11px' },
    width: 150,
  }, {
    Header: 'Documents for billing / เอกสารต้นฉบับ',
    columns: [
      {
        Header: 'Invoice / Tax Invoice',
        accessor: 'taxInvoice',
        width: 100,
        style: { textAlign: 'center' },
        Cell: row => row.value ? <Icon icon='check' /> : '-'
      }, {
        Header: 'Invoice',
        accessor: 'invoice',
        width: 80,
        style: { textAlign: 'center' },
        Cell: row => row.value ? <Icon icon='check' /> : '-'
      }, {
        Header: 'Receipt',
        accessor: 'receipt',
        width: 160,
        style: { textAlign: 'center', fontSize: '11px' },
        Cell: row => 'กรณีโอนเงิน กรุณาแนบใบเสร็จ'
      },
    ]
  }
]

const BillingCover = (props) => {
  const { billing, loading } = props
  const company = billing.company || {}
  const vendor = billing.vendor || {}
  const qrCodeData = billing.qrCode

  React.useEffect(() => {
    if (props.match.params.blId) {
      props.getBillingCover(props.match.params.blId)
    }
  }, [])

  const getBillingContactEmail = () => {
    if ((billing.billingContacts || []).length > 0) {
      return billing.billingContacts[0].email || '-'
    } else {
      return '-'
    }
  }

  return (
    <CoverContainer>
      <div className='titleContent'>
        Billing Cover Page
        <div className='accessoriesContent'>
          <CustomButton disable={loading} icon='print' title='PRINT' btnColor='gray' onClick={() => window.print()} />
        </div>
      </div>
      <div className='pageContainer'>
        <div className='documentDataContainer'>
          <div className='headerContent'>
            <div className='left'>
              <img src={logo} alt='' style={{ width: '160px', height: '71px' }} />
            </div>
            <div className='center'>
              <div className='specialCreditTerm'>
                {billing.specialCreditTerm ? '* Special Credit Term *' : ''}
              </div>
            </div>
            <div className='right'>
              <div className='t18b'>Billing Cover Page / ใบปะหน้า</div>
              <div className='t16'>Print Date :&nbsp;<Moment format='DD/MM/YYYY' /></div>
              <div className='t16'>Print Time :&nbsp;<Moment format='hh:mm:ss' /></div>
            </div>
          </div>
          <div className='t22b'>DT Group of Companies</div>
          <div className='separator' />
          {loading ? <ProgressBar /> :
            <div>
              <div className='dataContent'>
                <div className='left'>
                  <div className='t20b' style={{ marginBottom: '10px' }}>
                    Billing Number : {billing.documentNumber}
                  </div>
                  <div className='row'>
                    <div className='t14b'>Vendor Name : </div>
                    <div className='t14'>&nbsp;{vendor.name || ''}</div>
                  </div>
                  <div className='row'>
                    <div className='t14b'>Vendor Address : </div>
                    <div className='t14'>&nbsp;{vendor.address || ''}</div>
                  </div>
                  <div className='row' />
                  <div className='row'>
                    <div className='t14b'>Company Code : </div>
                    <div className='t14'>&nbsp;{company.code || ''}</div>
                  </div>
                  <div className='row'>
                    <div className='t14b'>Company Name : </div>
                    <div className='t14'>&nbsp;{company.name || ''}</div>
                  </div>
                  <div className='row'>
                    <div className='t14b'>Address : </div>
                    <div className='t14'>&nbsp;{billing.companyAddressTh || ''}</div>
                  </div>
                </div>
                {
                  billing.documentNumber ? 
                    <div className='right'>
                      <ReactQR text={qrCodeData} size={200} dotScale={0.8} />
                    </div> : null
                }
              </div>
              <ContactPointContainer>
                <div className='contactContent'>
                  <div className='contactGroupTitle'>Contact :</div>
                  {
                    (billing.billingContacts || [{}]).map(c =>
                      <div className='contactValueContent'>
                        <div className='contactValue'><Icon icon='user' />{c.name || ''}</div>
                        <div className='contactValue'><Icon icon='building' />Department : {c.department || ''}</div>
                        <div className='contactValue'><Icon icon='phone-square' />Tel : {c.tel || ''}</div>
                        <div className='contactValue'><Icon icon='envelope-square' />E-mail : {c.email || ''}</div>
                      </div>
                    )
                  }
                </div>
              </ContactPointContainer>
              {
                (billing.billingVendorContacts || []).length > 0 ?
                  <ContactPointContainer style={{ marginTop: '0px' }} >
                    <div className='contactContent'>
                      <div className='contactGroupTitle'>Vendor Contact :</div>
                      {
                        (billing.billingVendorContacts || [{}]).map(c =>
                          <div className='contactValueContent'>
                            <div className='contactValue'><Icon icon='user' />{c.name || ''}</div>
                            <div className='contactValue'><Icon icon='envelope-square' />E-mail : {c.email || ''}</div>
                            <div className='contactValue'><Icon icon='phone-square' />Tel : {c.tel || ''}</div>
                            <div className='contactValue'><Icon icon='mobile-alt' />Mobile : {c.mobile || ''}</div>
                          </div>
                        )
                      }
                    </div>
                  </ContactPointContainer> : null
              }
              <AttachContainer>
                <ReactTable
                  data={billing.payments || []}
                  columns={columns(billing.currencyCode || '')}
                  resizable={false}
                  minRows={1}
                  showPagination={false}
                  sortable={false}
                />
              </AttachContainer>
              {/* <div style={{ display: 'flex' }}>
                <span style={{ fontSize: '1rem', fontWeight: 'bold' }}>
                  หมายเหตุ
                </span>
                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '0.5rem' }}>
                  <span>Invoice(*) = กรณีที่ Vendor สะดวกนำส่งต้นฉบับพร้อมการวางบิล</span>
                </div>
              </div> */}
              <br />
              <Note 
                vendorCode={vendor.code || ''} 
                submittedDate={billing.submittedDate || new Date()} 
                companyName={company.name}
                documentNumber={billing.documentNumber}
                billingContactEmail={getBillingContactEmail()}
                companyTextInfo={billing.companyText1Th}
                noteTh={billing.noteTh}
                noteEn={billing.noteEn}
              />
            </div>
          }
        </div>
      </div>
    </CoverContainer>
  )
}

const mapStateToProps = (state) => ({
  billing: state.billform.billingCoverDetail.data,
  loading: state.billform.billingCoverDetail.loading
})

const mapDispatchToProps = {
  getBillingCover
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingCover)